import { CustomerTheme } from '@/modules/core/data/types/CustomerTheme';
import {
  css,
  useTheme,
} from '@emotion/react';
import React from 'react';

const SendSurvey = (props: Props): JSX.Element => {
  const theme: CustomerTheme = useTheme();
  const { primaryColor } = theme;
  return (
    <svg
      // @ts-ignore
      css={css`
        width: 130px;
        overflow: visible;

        @keyframes fly {
          0% {
            transform: translateX(0px);
          }
          20% {
            transform: translateX(-57px) rotate(-6deg);
          }
          40% {
            transform: translateX(100px);
          }
          45% {
            opacity: 1;
          }
          50% {
            transform: translateX(300px);
          }
          51% {
            opacity: 0;
          }
          100% {
            opacity: 0;
          }
        }

        @keyframes throw {
          0% {
            transform: translateX(0px);
          }
          20% {
            transform: translateX(-50px) translateY(10px) rotate(-10deg);
          }
          40% {
            transform: translateX(90px) translateY(10px) rotate(+10deg);
          }
          70% {
            transform: translateX(20px) translateY(10px) rotate(0deg);
          }
          100% {
            transform: translateX(0px);
          }
        }

        .plane-outlined, .plane {
          animation: fly 3.5s ease-in;
          overflow: visible;
          transform-origin: 63% 37%;
        }

        .plane {
          fill: ${primaryColor};
        }

        .hand {
          animation: throw 3.5s ease-in;
          overflow: visible;
          transform-origin: 38% 56%;
        }
      `}
      id="SendSurvey_svg__Calque_1"
      x={0} y={0}
      viewBox="0 0 300 300"
      xmlSpace="preserve"
      {...props}
    >
      <style>{'.SendSurvey_svg__st0{fill:#fff}'}</style>
      <path
        className="hand SendSurvey_svg__st0"
        d="M62.5 181.1c2.3-2.2 4-4.8 5.2-7.8v-.1s.9-2.5 1.5-5.3c1.1-5.5 5.3-34.7 7.1-44.6.3-1.8 1.2-6 4.5-8.9 1.4-1.2 2.8-1.8 3.4-2 20.9-8.2 29.4-10.5 41.5-13.7 4.4-1.2 8.3-2.1 13.2-1.1 4.4 1 7.7 3.2 9.5 4.8 17.1 17.5 17.7 24.9 17.7 24.9.8 3-.6 9.4-3.2 10.4-2.6 1.1-6.1.4-7.7-1.2s-17.1-12.4-17.1-12.4c-1 .1-2.6.3-4.2 1.1-.8.3-3.9 1.8-5.6 5-2 3.8-.7 7.7.3 10.7 1 3.1 2.3 7.2 6.3 9.5 4.2 2.4 9.8 2 13.7-.3 7-4.1 5.7-9.3 10.8-16.3 1.7-2.3 12.1-2.5 17.6-1.8 5.5.7 3.4 6.4 3.4 6.4s-12.2 23.6-16.7 31.4c-4.5 7.8-13.7 19.6-13.7 19.6-4.6 4.5-9.5 6.5-14.6 8.5-6.9 2.8-9 2.3-16.7 4.9-.9.3-8.5 2.9-15.7 7-5.5 3.1-14.1 9.1-22.4 20.1 0 0-12.2-4.5-20.4-10.5S44.8 198 44.8 198l17.7-16.9z"
      />
      <path
        className="hand"
        d="M81 231.3l-.7-.3c-.5-.2-12.4-4.6-20.6-10.6-8.3-6.1-15.4-21.2-15.7-21.8l-.3-.6 18.2-17.6c2.2-2.1 3.9-4.7 4.9-7.4 0-.1 1-2.6 1.5-5.2.5-2.7 1.9-11.3 3.3-20.3 1.5-9.5 3-19.2 3.9-24.2.3-1.7 1.2-6.3 4.9-9.5 1.6-1.3 3.1-1.9 3.7-2.2 21.4-8.4 29.9-10.7 41.6-13.8 4.3-1.1 8.4-2.2 13.6-1.1 3.6.8 6.9 2.5 10 5l.1.1c16.2 16.7 17.9 24.4 18 25.4.3 1 .3 2.3.2 3.7 3.7-.2 7.6 0 9.8.2 1.8.2 3.2 1 3.9 2.3 1.4 2.3.3 5.4.2 5.5v.1c-.1.2-12.3 23.7-16.8 31.4-4.5 7.7-13.6 19.6-13.7 19.7l-.1.1c-4.8 4.6-9.7 6.6-14.9 8.7-3.8 1.5-6.3 2.1-8.8 2.7-2.2.5-4.5 1.1-7.9 2.2-.8.3-8.5 2.9-15.5 6.9-8.4 4.8-15.8 11.5-22.1 19.9l-.7.7zm-35-32.9c1.4 3 7.8 15.3 14.8 20.4 6.9 5 16.8 9 19.5 10.1 6.4-8.4 13.8-15 22.2-19.8 7-4 14.4-6.6 15.8-7.1 3.6-1.2 6-1.8 8.1-2.3 2.6-.6 4.9-1.1 8.6-2.6 5-2 9.8-3.9 14.3-8.3.7-.9 9.2-12.1 13.5-19.5 4.4-7.5 16-29.9 16.7-31.3.1-.3.7-2.4-.1-3.7-.4-.7-1.2-1.1-2.5-1.3-3-.4-6.7-.4-9.9-.2-.6 2.7-1.9 5.2-3.6 5.9-1.7.7-3.9.7-5.8.2-.5 1-.8 1.9-1.2 2.8-1.5 3.6-2.8 6.7-7.3 9.3-4.5 2.7-10.5 2.8-14.7.3-4.3-2.5-5.7-6.9-6.7-10.1-1-3.1-2.4-7.4-.2-11.5 1.6-3.1 4.5-4.7 6.1-5.4 1.4-.6 3-1 4.6-1.1h.4l.3.2c.6.4 15.6 10.9 17.2 12.5.2.2.4.4.7.5.5-1 1.2-2 2-3.1.9-1.3 3.6-2 6.7-2.3.2-1.3.2-2.5-.1-3.4v-.2c0-.1-1-7.4-17.4-24.3-2.8-2.3-5.8-3.8-9.1-4.5-4.7-1-8.6 0-12.7 1.1-11.7 3.1-20.1 5.3-41.4 13.7-.5.2-1.8.7-3.1 1.8-3.2 2.7-3.9 6.8-4.2 8.3-.9 5-2.4 14.7-3.9 24.2-1.4 9.1-2.7 17.7-3.3 20.4-.6 2.8-1.5 5.3-1.6 5.4-1.2 3.1-3 5.9-5.4 8.2L46 198.4zm91.9-73.2c-1.2.1-2.4.4-3.6.9-1.3.6-3.8 2-5.1 4.5-1.8 3.4-.6 7 .4 10 1 3.1 2.2 6.9 5.8 9 3.6 2.1 8.8 2 12.7-.3 3.9-2.3 5-5 6.4-8.4.4-.9.8-1.8 1.2-2.8-.4-.3-.8-.5-1.2-.9-1.2-1.1-12.1-8.8-16.6-12zm20.7 11.9c1.3.3 2.8.3 4.1-.2 1-.4 1.8-2 2.3-3.8-2.4.3-4.2.8-4.7 1.4-.7.9-1.3 1.8-1.7 2.6z"
      />
      <path
        className="plane"
        d="M255.2 101.7v-.1s0-.1-.1-.1c0 0 0-.1-.1-.1 0-.1-.1-.1-.2-.2 0 0 0-.1-.1-.1-.1-.1-.2-.1-.3-.2H254.1l-134-3c-.5 0-.9.3-1 .8-.1.5.1.9.5 1.1l25.2 12.8-7.6 28.8c-.1.4.1.9.5 1.1.1.1.3.1.5.1l27.6.3 19.4-9.9 17.3 8.8c.1.1.3.1.5.1s.4-.1.6-.2l51-39c.1 0 .1-.1.1-.1l.1-.1c.1-.1.1-.2.1-.3v-.1-.3c.3 0 .3-.1.3-.1z"
        fill="#0028ff"
      />
      <path
        className="plane-outlined"
        d="M255.2 101.7v-.1s0-.1-.1-.1c0 0 0-.1-.1-.1 0-.1-.1-.1-.2-.2 0 0 0-.1-.1-.1-.1-.1-.2-.1-.3-.2H254.1l-134-3c-.5 0-.9.3-1 .8-.1.5.1.9.5 1.1l25.2 12.8-7.6 28.8c-.1.4.1.9.5 1.1.1.1.3.1.5.1l27.6.3 19.4-9.9 17.3 8.8c.1.1.3.1.5.1s.4-.1.6-.2l51-39c.1 0 .1-.1.1-.1l.1-.1c.1-.1.1-.2.1-.3v-.1-.3c.3 0 .3-.1.3-.1zM124.6 100l112.4 2.5-90.6 8.5-21.8-11zm40.9 40.9l-25-.3 18.3-21 24.3 12.3-17.6 9zm37.6-1.2l-41.3-20.9 88.6-15.3-47.3 36.2z"
      />
      <g>
        <path
          className="hand SendSurvey_svg__st0"
          d="M76.3 123.4c-1.8 9.9-6 39.1-7.1 44.6-.6 2.8-1.5 5.3-1.5 5.3v.1c-1.1 2.9-2.9 5.6-5.2 7.8l-17.7 17.1s7.2 15.5 15.4 21.4c8.2 6 20.4 10.5 20.4 10.5 8.3-11 16.9-17 22.4-20.1 7.1-4.1 14.8-6.7 15.7-7 7.7-2.6 9.8-2.2 16.7-4.9 5.1-2.1 10-4 14.6-8.5 0 0 9.1-11.8 13.7-19.6 4.5-7.8 16.7-31.4 16.7-31.4s2.1-5.7-3.4-6.4c-5.5-.7-15.9-.5-17.6 1.8-5.1 7-3.9 12.2-10.8 16.3-3.9 2.3-9.5 2.7-13.7.3-3.9-2.3-5.3-6.4-6.3-9.5-1-3-2.3-7-.3-10.7"
        />
        <path
          className="hand"
          d="M81 231.3l-.7-.3c-.5-.2-12.4-4.6-20.6-10.6-8.3-6.1-15.4-21.2-15.7-21.8l-.3-.6 18.2-17.6c2.2-2.1 3.9-4.7 4.9-7.4 0-.1 1-2.6 1.5-5.2.5-2.7 1.9-11.3 3.3-20.3 1.5-9.5 3-19.2 3.9-24.2l2 .4c-.9 5-2.4 14.7-3.9 24.2-1.4 9.1-2.7 17.7-3.3 20.4-.6 2.8-1.5 5.3-1.6 5.4-1.2 3.1-3 5.9-5.4 8.2L46 198.4c1.4 3 7.8 15.3 14.8 20.4 6.9 5 16.8 9 19.5 10.1 6.4-8.4 13.8-15 22.2-19.8 7-4 14.4-6.6 15.8-7.1 3.6-1.2 6-1.8 8.1-2.3 2.6-.6 4.9-1.1 8.6-2.6 5-2 9.8-3.9 14.3-8.3.7-.9 9.2-12.1 13.5-19.5 4.4-7.5 16-29.9 16.7-31.3.1-.3.7-2.4-.1-3.7-.4-.7-1.2-1.1-2.5-1.3-6.1-.8-15.5-.2-16.7 1.4-1.9 2.7-2.9 5-3.8 7.3-1.5 3.6-2.8 6.7-7.3 9.3-4.5 2.7-10.5 2.8-14.7.3-4.3-2.5-5.7-6.9-6.7-10.1-1-3.1-2.4-7.4-.2-11.5l1.8.9c-1.8 3.4-.6 7 .4 10 1 3.1 2.2 6.9 5.8 9 3.6 2.1 8.8 2 12.7-.3 3.9-2.3 5-5 6.4-8.4.9-2.3 2-4.8 4.1-7.7 2.2-3 14-2.8 18.5-2.2 1.8.2 3.2 1 3.9 2.3 1.4 2.3.3 5.4.2 5.5v.1c-.1.2-12.3 23.7-16.8 31.4-4.5 7.7-13.6 19.6-13.7 19.7l-.1.1c-4.8 4.6-9.7 6.6-14.9 8.7-3.8 1.5-6.3 2.1-8.8 2.7-2.2.5-4.5 1.1-7.9 2.2-.8.3-8.5 2.9-15.5 6.9-8.4 4.8-15.8 11.5-22.1 19.9l-.5.8z"
        />
      </g>
    </svg>
  );
};

type Props = {} & React.SVGProps<SVGSVGElement>;
export default SendSurvey;
